<template>
  <section
    :id
    class="relative my-spacing-base overflow-hidden tablet:my-spacing-lg"
  >
    <BlokkliField
      v-slot="{ items }"
      name="field_paragraphs"
      :list="filterNullArray(paragraphs)"
      :should-render-item
      proxy-mode
    >
      <LazyParagraphSliderRenderer :key="getKey(items)" :items="items" />
    </BlokkliField>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphSliderFragment } from '#graphql-operations'
import type { FieldListItem } from '#blokkli/types'
import { filterNullArray } from '~/helpers'

defineProps<{
  paragraphs?: ParagraphSliderFragment['paragraphs']
}>()

const { index, siblings } = defineBlokkli({
  bundle: 'slider',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  editor: {
    disableEdit: true,
  },
  propsFieldMapping: {
    paragraphs: { type: 'field', name: 'field_paragraphs' },
  },
})

const { shouldRenderItem } = useParagraphVisiblity()
const id = useParagraphAnchorId(index, siblings)
const isEditing = false

function getKey(items: FieldListItem[]) {
  if (isEditing) {
    // During editing, we have to force a rerender of the slider when the count
    // or the order of paragraphs changes.
    return items.map((v) => v.uuid).join('-')
  }

  return 'slider'
}
</script>
